import { IconToggle } from '@ui';
import { CSShiftTimeGroup } from '@/api/apis/resources/schedule';
import { shiftTimeGroupNames } from '@/constants/schedule.constants';

type CSTimeGroupToggleProps = {
  value: CSShiftTimeGroup;
  onChange: (value: CSShiftTimeGroup) => void;
};

export const CSTimeGroupToggle = ({ value, onChange }: CSTimeGroupToggleProps) => {
  return (
    <IconToggle
      size="sm"
      isSelected={value === CSShiftTimeGroup.GroupB}
      onValueChange={(isSelected) => onChange(isSelected ? CSShiftTimeGroup.GroupB : CSShiftTimeGroup.GroupA)}
      disableIcon={<span>{shiftTimeGroupNames[CSShiftTimeGroup.GroupA]}</span>}
      enableIcon={<span>{shiftTimeGroupNames[CSShiftTimeGroup.GroupB]}</span>}
    />
  );
};
